import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { API_VERSION, DIRECT_TRUST_PATH } from './RestApiConstants';

function deleteConnectedApplicationsSecretRequestConfig(appId: string, secretId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'DELETE',
    endpoint: `${DIRECT_TRUST_PATH}/${appId}/secrets/${secretId}`,
    serverWideRequest: false
  };
}

export function callDeleteConnectedApplicationsSecret(appId: string, secretId: string) {
  return makeJsonRestApiRequest<void, IResult>({
    config: deleteConnectedApplicationsSecretRequestConfig(appId, secretId),
    request: null,
  });
}